import { assignment as initialState } from "reducers/initialState.tsx";
import {
    REQUEST_ASSIGNED_CASES_WITH_APPTS,
    RECEIVE_ASSIGNED_CASES_WITH_APPTS,
    ERROR_ASSIGNED_CASES_WITH_APPTS,
    REQUEST_ASSIGNMENT_CONFIG,
    RECEIVE_ASSIGNMENT_CONFIG,
    ERROR_ASSIGNMENT_CONFIG,
    REQUEST_CASE_LOCATIONS,
    RECEIVE_CASE_LOCATIONS,
    ERROR_CASE_LOCATIONS,
    REQUEST_INSPECTOR_LOCATIONS,
    RECEIVE_INSPECTOR_LOCATIONS,
    ERROR_INSPECTOR_LOCATIONS,
    REQUEST_ZIP_CODES,
    RECEIVE_ZIP_CODES,
    ERROR_ZIP_CODES,
    REQUEST_CASE_DETAILS,
    RECEIVE_CASE_DETAILS,
    ERROR_CASE_DETAILS,
    REQUEST_ASSIGNED_CASES,
    RECEIVE_ASSIGNED_CASES,
    ERROR_ASSIGNED_CASES,
    REQUEST_INSPECTOR_DETAILS,
    RECEIVE_INSPECTOR_DETAILS,
    ERROR_INSPECTOR_DETAILS,
    REMOVE_CASE_FROM_CASE_DETAILS,
    CLEAR_MAP_SELECTION,
    CLEAR_INSPECTOR_DETAILS,
    CLEAR_ASSIGNMENT_TOOL_MEMORY,
    REMOVE_CASES_FROM_MAP,
    REQUEST_ASSIGN_CASE,
    RECEIVE_ASSIGN_CASE,
    ERROR_ASSIGN_CASE,
    REQUEST_UNASSIGN_CASE,
    RECEIVE_UNASSIGN_CASE,
    ERROR_UNASSIGN_CASE,
    REQUEST_FR_PAY_SUMMARY,
    RECEIVE_FR_PAY_SUMMARY,
    ERROR_FR_PAY_SUMMARY,
    REQUEST_APPRAISAL_CASE_LOCATIONS_COUNT,
    RECEIVE_APPRAISAL_CASE_LOCATIONS_COUNT,
    ERROR_APPRAISAL_CASE_LOCATIONS_COUNT,
    REQUEST_INSURANCE_CASE_LOCATIONS_COUNT,
    RECEIVE_INSURANCE_CASE_LOCATIONS_COUNT,
    ERROR_INSURANCE_CASE_LOCATIONS_COUNT,
    PIN_TYPE_SELECTED_CHANGE,
    COUNTIES_SELECTED_CHANGE,
    DAYS_OLD_OPTION_SELECTED_CHANGE,
    DAYS_TILL_DUE_OPTION_SELECTED_CHANGE,
    EXTRA_FILTERS_SELECTED_CHANGE,
    CASE_ID_FILTER_CHANGE,
    SHOW_EXTRA_DETAILS_CHANGE,
    SELECTION_DETAILS_MODE_CHANGE,
    SELECTED_INSPECTOR_CHANGE,
    FR_GEO_COVERAGE_MODE,
    SERVICE_REGION_DRAWN,
    UPDATE_ASSIGNED_CASES_WITH_APPTS_PINS,
} from "typeConstants";

const assignment = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_ASSIGNED_CASES_WITH_APPTS_PINS:
            return {
                ...state,
                assignedCasesWithAppts: state.assignedCasesWithAppts.map(c => {
                    //A pin on a case could have been changed to grey when selecting a different FR. This makes sure it changes back to blue when selecting a new FR and it's their appointment case
                    if (c.inspectorInfo.inspectorNumber === action.payload.selectedInspectorNumber && c.appointmentDate)
                        return { ...c, pinGroupingConfigId: action.payload.selectedInspectorPinId};
                    //Changes pin to grey if there's an appointment date but for a different FR
                    else if (c.appointmentDate)
                        return { ...c,  pinGroupingConfigId: action.payload.otherPinId };
                    else return { ...c };
                  }),
            };
        case REQUEST_ASSIGNED_CASES_WITH_APPTS:
            return {
                ...state,
                isFetchingCasesWithAppointments: true,
            };
        case RECEIVE_ASSIGNED_CASES_WITH_APPTS:
            return {
                ...state,
                isFetchingCasesWithAppointments: false,
                assignedCasesWithAppts: action.payload.caseLocations,
            };
        case ERROR_ASSIGNED_CASES_WITH_APPTS:
            return {
                ...state,
                isFetchingCasesWithAppointments: false,
            };
        case REQUEST_ASSIGNMENT_CONFIG:
            return {
                ...state,
                config: { ... state.config, isFetching: true }
            };
        case RECEIVE_ASSIGNMENT_CONFIG:
            return {
                ...state,
                config: { ... action.payload, isFetching: false }
            };
        case ERROR_ASSIGNMENT_CONFIG:
            return {
                ...state,
                config: { ... state.config, isFetching: false }
            };
        case REQUEST_CASE_LOCATIONS:
            return {
                ...state,
                isFetchingCases: true
            };
        case RECEIVE_CASE_LOCATIONS:
            return {
                ...state,
                isFetchingCases: false,
                cases: action.payload.caseLocations
            };
        case ERROR_CASE_LOCATIONS:
            return {
                ...state,
                isFetchingCases: false
            };
        case REQUEST_INSPECTOR_LOCATIONS:
            return {
                ...state,
                isFetchingInspectors: true
            };
        case RECEIVE_INSPECTOR_LOCATIONS:
            return {
                ...state,
                isFetchingInspectors: false,
                inspectors: action.payload.inspectorLocations
            };
        case ERROR_INSPECTOR_LOCATIONS:
            return {
                ...state,
                isFetchingInspectors: false
            };
        case REQUEST_ZIP_CODES:
            return {
                ...state,
                isFetchingZipCodes: true
            };
        case RECEIVE_ZIP_CODES:
            return {
                ...state,
                isFetchingZipCodes: false,
                zipCodes: action.payload
            };
        case ERROR_ZIP_CODES:
            return {
                ...state,
                isFetchingZipCodes: false
            };

        case REQUEST_CASE_DETAILS:
            return {
                ...state,
                isFetchingCaseDetails: true
            };
        case RECEIVE_CASE_DETAILS:
            return {
                ...state,
                isFetchingCaseDetails: false,
                caseDetails: action.payload.cases
            };
        case ERROR_CASE_DETAILS:
            return {
                ...state,
                isFetchingCaseDetails: false
            };
        case REQUEST_ASSIGNED_CASES:
            return {
                ...state,
                isFetchingAssignedCases: true,
                assignedCases: null
            };
        case RECEIVE_ASSIGNED_CASES:
            return {
                ...state,
                isFetchingAssignedCases: false,
                assignedCases: action.payload.cases
            };
        case ERROR_ASSIGNED_CASES:
            return {
                ...state,
                isFetchingAssignedCases: false
            };
        case REMOVE_CASE_FROM_CASE_DETAILS:
            return {
                ...state,
                caseDetails: state.caseDetails.filter(c => !action.payload.includes(c.caseLocation.caseId))
            };
        case CLEAR_MAP_SELECTION:
            return {
                ...state,
                caseDetails: null,
                isFetchingInspectorDetails: false,
                inspectorDetails: null
            };
        case CLEAR_INSPECTOR_DETAILS:
            return {
                ...state,
                isFetchingInspectorDetails: false,
                inspectorDetails: null
            };
        case CLEAR_ASSIGNMENT_TOOL_MEMORY:
            return {
                ...state,
                cases: null,
                caseDetails: null,
                inspectorDetails: null,
                inspectors: null,
                zipCodes: null
            };
        case REMOVE_CASES_FROM_MAP:
            return {
                ...state,
                cases: state.cases ? state.cases.filter(c => !action.payload.includes(c.caseId)) : null,
                caseDetails: state.caseDetails ? state.caseDetails.filter(c => !action.payload.includes(c.caseLocation.caseId)) : null
            };
        case REQUEST_INSPECTOR_DETAILS:
            return {
                ...state,
                isFetchingInspectorDetails: true
            };
        case RECEIVE_INSPECTOR_DETAILS:
            return {
                ...state,
                isFetchingInspectorDetails: false,
                inspectorDetails: action.payload
            };
        case ERROR_INSPECTOR_DETAILS:
            return {
                ...state,
                isFetchingInspectorDetails: false
            };
            case REQUEST_FR_PAY_SUMMARY:
            return {
              ...state,
              isFetchingInspectorPayPeriodSummary: true
            };
          case RECEIVE_FR_PAY_SUMMARY:
            return {
              ...state,
              isFetchingInspectorPayPeriodSummary: false,
              inspectorPayPeriodSummary: action.payload
            };
          case ERROR_FR_PAY_SUMMARY:
            return {
              ...state,
              isFetchingInspectorPayPeriodSummary: false
            };
        case REQUEST_ASSIGN_CASE:
            return {
                ...state,
                assignStatus: { assigning: true, success: null },
            };
        case RECEIVE_ASSIGN_CASE:
            return {
                ...state,
                assignStatus: { assigning: false, success: true },
            };
        case ERROR_ASSIGN_CASE:
            return {
                ...state,
                assignStatus: { assigning: false, success: false },
            };
        case REQUEST_UNASSIGN_CASE:
            return {
                ...state,
                unassignStatus: { unassigning: true, success: null },
            };
        case RECEIVE_UNASSIGN_CASE:
            return {
                ...state,
                unassignStatus: { unassigning: false, success: true },
            };
        case ERROR_UNASSIGN_CASE:
            return {
                ...state,
                unassignStatus: { unassigning: false, success: false },
            };
        case REQUEST_APPRAISAL_CASE_LOCATIONS_COUNT:
            return {
                ...state,
                appraisalCaseCount: null
            };
        case RECEIVE_APPRAISAL_CASE_LOCATIONS_COUNT:
            return {
                ...state,
                appraisalCaseCount: action.payload
            };
        case ERROR_APPRAISAL_CASE_LOCATIONS_COUNT:
            return {
                ...state,
                appraisalCaseCount: null
            };
        case REQUEST_INSURANCE_CASE_LOCATIONS_COUNT:
            return {
                ...state,
                insuranceCaseCount: null
            };
        case RECEIVE_INSURANCE_CASE_LOCATIONS_COUNT:
            return {
                ...state,
                insuranceCaseCount: action.payload
            };
        case ERROR_INSURANCE_CASE_LOCATIONS_COUNT:
            return {
                ...state,
                insuranceCaseCount: null
            };
        case PIN_TYPE_SELECTED_CHANGE:
            return {
                ...state,
                pinTypesSelected: action.payload,
            };
        case COUNTIES_SELECTED_CHANGE:
            return {
                ...state,
                countiesSelected: action.payload,
            };
        case DAYS_OLD_OPTION_SELECTED_CHANGE:
            return {
                ...state,
                daysOldOptionSelected: action.payload,
            };
        case DAYS_TILL_DUE_OPTION_SELECTED_CHANGE:
            return {
                ...state,
                daysTillDueSelected: action.payload,
            };
        case EXTRA_FILTERS_SELECTED_CHANGE:
            return {
                ...state,
                extraFiltersSelected: action.payload,
            };
        case CASE_ID_FILTER_CHANGE:
            return  {
                ...state,
                caseIdFilter: action.payload,
            };
        case SHOW_EXTRA_DETAILS_CHANGE:
            return {
                ...state,
                showExtraDetails: action.payload,
            };
        case SELECTION_DETAILS_MODE_CHANGE:
            return {
                ...state,
                selectionDetailsMode: action.payload,
            };
        case SELECTED_INSPECTOR_CHANGE:
            return {
                ...state,
                selectedInspector: action.payload,
            };
        case FR_GEO_COVERAGE_MODE:
            return {
                ...state,
                isFRGeoCoverageMode: action.payload,
            };
        case SERVICE_REGION_DRAWN:
            return {
                ...state,
                tempFRGeoServiceRegion: action.payload,
            };
        default:
            return state;
    }
};

export default assignment;